module.exports = __webpack_public_path__ + "static/img/mail.1ab96ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/mail.png
// module id = MiSB
// module chunks = 0